/**
 * <s-custom-fit> — toggles the custom-fit measurement fields. Unticked fields are disabled so they never
 * submit; the hidden [data-cf-fee] extra_line input is enabled only when ticked. Values persist in
 * sessionStorage so a variant change (which re-renders the product-form partial) keeps them.
 */
class SCustomFit extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-cf-toggle]');
    this.fields = this.querySelector('[data-cf-fields]');
    this.fee = this.querySelector('[data-cf-fee]');
    if (!this.toggle || !this.fields) return;
    this.inputs = [...this.fields.querySelectorAll('input')];
    this.restore();
    this.toggle.addEventListener('change', () => { this.sync(); this.save(); });
    this.inputs.forEach((i) => i.addEventListener('input', () => this.save()));
    this.sync();
  }

  sync() {
    const on = this.toggle.checked;
    this.fields.hidden = !on;
    if (this.fee) this.fee.disabled = !on;
    this.inputs.forEach((i) => {
      i.disabled = !on;
      if (i.hasAttribute('data-cf-required')) i.required = on;
    });
  }

  save() {
    try {
      const data = { on: this.toggle.checked, values: this.inputs.map((i) => i.value) };
      sessionStorage.setItem(this.dataset.key, JSON.stringify(data));
    } catch (e) { /* storage unavailable */ }
  }

  restore() {
    try {
      const data = JSON.parse(sessionStorage.getItem(this.dataset.key) || 'null');
      if (!data) return;
      this.toggle.checked = !!data.on;
      this.inputs.forEach((i, n) => { if (data.values?.[n] != null) i.value = data.values[n]; });
    } catch (e) { /* ignore */ }
  }
}

if (!customElements.get('s-custom-fit')) customElements.define('s-custom-fit', SCustomFit);
